/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuoteRuleDimension {
    Source = 1,
    BillingCustomer = 2,
    VehicleType = 3,
    FrontInbox = 4,
}
